import api from "../../utils/apiUserTienda";

export const getRoles = async () => {
  const res = await api.get("/api/tienda/roles/obtener");
  return res.data.roles; 
};
export const createRole = async (data) => {
  const res = await api.post("/api/tienda/roles/crear", data);
  return res.data;
};

export const updateRole = async (id, data) => {
  const res = await api.put(`/api/tienda/roles/actualizar/${id}`, data);
  return res.data;
};

export const getRolesActivos = async () => {
  const res = await api.get("/api/tienda/roles/obtener/activos");
  return res.data.roles; 
};